var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFlechaBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.119,
    height: 50.119,
    viewBox: "0 0 50.119 50.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_998",
    "data-name": "Grupo 998",
    transform: "translate(50.119 50.119) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_123",
    "data-name": "Elipse 123",
    cx: 25.059,
    cy: 25.059,
    r: 25.059,
    transform: "translate(0 0)",
    fill: "#0af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_996",
    "data-name": "Grupo 996",
    transform: "translate(21.548 16.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_694",
    "data-name": "Trazado 694",
    d: "M6.989,0,0,8.156l6.989,8.36",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlechaBlue);
export default __webpack_public_path__ + "static/media/ic_flecha_blue.730d98fd58c96f79a506c817e4147db6.svg";
export { ForwardRef as ReactComponent };